import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function SocialTwitterFillIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 5.796a8.192 8.192 0 01-2.357.646 4.115 4.115 0 001.805-2.27 8.197 8.197 0 01-2.606.996 4.105 4.105 0 00-6.992 3.743 11.65 11.65 0 01-8.456-4.287 4.107 4.107 0 001.27 5.478 4.084 4.084 0 01-1.86-.513v.052a4.105 4.105 0 003.292 4.023 4.168 4.168 0 01-1.854.071 4.108 4.108 0 003.832 2.85A8.26 8.26 0 012 18.282a11.61 11.61 0 006.29 1.844A11.595 11.595 0 0019.949 7.923 8.361 8.361 0 0022 5.796z",
    fill: "#1DA1F2"
  }));
}
export default SocialTwitterFillIcon;